import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { InterceptorMessageService } from 'projects/dop-core/src/public-api';
import { PercentageLoadingService } from './percentage-loading.service';

@Component({
  selector: 'app-percentage-loading',
  templateUrl: './percentage-loading.component.html',
  styleUrls: ['./percentage-loading.component.scss']
})
export class PercentageLoadingComponent implements OnInit, OnDestroy {
  visibleSubscription: any;

  percentage = 0;
  @Input() showLoading = false;
  percentageSubscription: any;

  constructor(
    private percentageLoadingService: PercentageLoadingService,
    private interceptorMessageService: InterceptorMessageService) {
    this.interceptorMessageService.apiNetworkError.subscribe(() => {
      this.showLoading = false;
    });
  }

  ngOnInit(): void {
    this.percentageSubscription = this.percentageLoadingService.percentage.subscribe((percentage: number) => {
      this.percentage = percentage;
      if (this.percentage === 100 || this.percentage === -1) {
        this.showLoading = false;
      } else {
        this.showLoading = true;
      }
    });
    this.visibleSubscription = this.percentageLoadingService.visible.subscribe((isVisible: boolean) => {
      this.showLoading = isVisible;
    });
  }

  ngOnDestroy(): void {
    this.percentageSubscription.unsubscribe();
    this.visibleSubscription.unsubscribe();
  }

}
